/**
 * 司机端账号相关 H5 路径（含嵌入原生 WebView 的 native 变体，与 DeliveringPath 中 *_NATIVE 约定一致）。
 */
export enum DriverAuthPath {
    DRIVER_REGISTER = "/driver/register",
    DRIVER_REGISTER_NATIVE = "/driver/register/native",
    DRIVER_TERMS_OF_USE_NATIVE = "/driver/terms-of-use/native",
    DRIVER_PRIVACY_POLICY_NATIVE = "/driver/privacy-policy/native",
    DRIVER_CHANGE_PASSWORD_NATIVE = "/driver/changePassword/native",
    DRIVER_BLACKLIST_SMS_VERIFICATION_NATIVE = "/driver/blacklist-sms-verification/native",
}
